import styles from "./AttachmentToastContent.module.scss"

interface AttachmentToastContentProps {
    iconSrc: string
    message: string
}

export const AttachmentToastContent = ({ iconSrc, message }: AttachmentToastContentProps) => (
    <div className={styles.content}>
        <img src={iconSrc} alt="warning" className={styles.icon} />
        <span className={styles.message}>{message}</span>
    </div>
)
